const FilenameMixin = {
	methods: {
		stripTimestamp(name) {
			return name
				.split(".")
				.filter((value, key) => key < name.split(".").length - 2 || key > name.split(".").length - 2)
				.join(".");
		},
		stripExtension(name) {
			return name
				.split(".")
				.filter((value, key) => key < name.split(".").length - 1)
				.join(".");
		},
		stripTimestampAndExtension(name) {
			return name
				.split(".")
				.filter((value, key) => key < name.split(".").length - 2)
				.join(".");
		},
		capitalizeFirstLetter(string) {
			if (string) return string[0].toUpperCase() + string.slice(1);
		},
	},
};

export default FilenameMixin;
